
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class CreditMemoService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.acc_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_CM_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static initCreditMemoModule(input, responseCallBack, errorCallBack) {
    this.method("initCreditMemoModule", input, responseCallBack, errorCallBack);
  }
  static createCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("createCreditMemo", input, responseCallBack, errorCallBack);
  }
  static readCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("readCreditMemo", input, responseCallBack, errorCallBack);
  }
  static updateCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("updateCreditMemo", input, responseCallBack, errorCallBack);
  }
  static getCreditMemoPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCreditMemoPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getValidCreditMemosForInvoiceNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getValidCreditMemosForInvoiceNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getRollLinesForInvoiceNumbers(input, responseCallBack, errorCallBack) {
    this.method(
      "getRollLinesForInvoiceNumbers",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("approveCreditMemo", input, responseCallBack, errorCallBack);
  }
  static unApproveCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("unApproveCreditMemo", input, responseCallBack, errorCallBack);
  }
  static cancelCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("cancelCreditMemo", input, responseCallBack, errorCallBack);
  }
  static createAndApproveCreditMemo(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveCreditMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveCreditMemo(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveCreditMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockCreditMemoNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockCreditMemoNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAppliedInvoicesForCreditMemoList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAppliedInvoicesForCreditMemoList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAndAppliedAmountForCreditMemoReturnPayment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAndAppliedAmountForCreditMemoReturnPayment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForOpenTenderCreditData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForOpenTenderCreditData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForOpenReturnCreditData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForOpenReturnCreditData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForOpenDiscountCreditData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForOpenDiscountCreditData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForAvailableCreditData(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForAvailableCreditData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveCreditMemoThenGenerateCreditMemoReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveCreditMemoThenGenerateCreditMemoReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateAndApproveCreditMemoThenGenerateCreditMemoReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveCreditMemoThenGenerateCreditMemoReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static adjustCreditMemo(input, responseCallBack, errorCallBack) {
    this.method("adjustCreditMemo", input, responseCallBack, errorCallBack);
  }

  static getCreditMemoListForLast3MonthsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForLast3MonthsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForLast6MonthsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForLast6MonthsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForLast12MonthsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForLast12MonthsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForLast18MonthsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForLast18MonthsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCreditMemoListForLast24MonthsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemoListForLast24MonthsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
    static getCreditMemosForDashBoard(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCreditMemosForDashBoard",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.acc_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.acc_data_url,responseCallBack, errorCallBack);
    }
  }
}
